import * as Yup from "yup";
import { ArtistTermsSchemaFragment } from "../../common/components/ArtistTermsAndConditions/ArtistTermsSchemaFragment";

const EmailPasswordSchemaFragment = {
  password: Yup.string()
    .min(6, "form-error-password")
    .required("form-error-password-required"),
  confirm_password: Yup.string().test(
    "passwords-match",
    "form-error-password-match",
    function (value) {
      return this.parent.password === value;
    }
  ),
  email: Yup.string()
    .max(128, "form-error-email-max")
    .email("form-error-email")
    .required("form-error-email-required"),
};

export const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email("form-error-email")
    .required("form-error-email-required"),
  password: Yup.string()
    .min(6, "form-error-password")
    .required("form-error-password-required"),
  remember: Yup.boolean(),
});

export const forgotPassword = Yup.object().shape({
  email: Yup.string()
    .email("form-error-email")
    .required("form-error-email-required"),
});

export const resetPassword = Yup.object().shape({
  password: Yup.string()
    .min(6, "form-error-password")
    .required("form-error-password-required"),
  confirm_password: Yup.string().test(
    "passwords-match",
    "form-error-password-match",
    function (value) {
      return this.parent.password === value;
    }
  ),
});

export const signupUserSchema = Yup.object().shape({
  // username: is validated on field level to avoid unnecessary api calls
  ...EmailPasswordSchemaFragment,
});

export const signupArtistSchema = Yup.object().shape({
  // username: is validated on field level to avoid unnecessary api calls
  ...EmailPasswordSchemaFragment,
  ...ArtistTermsSchemaFragment,
});

export const createProfileSchema = Yup.object().shape({
  bio: Yup.string().min(6).max(1024).required("form-error-required"),
});

export const editEmailSchema = Yup.object().shape({
  ...EmailPasswordSchemaFragment,
});
